import React, {useCallback, useState} from 'react';
import {useAuth} from '../service';

export const Login = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const {mutateAsync: login} = useAuth().login;

  const handleSubmit = useCallback(
    async (e) => {
      const {username, password} = formData;
      e.preventDefault();
      setLoading(true);
      await login({email: username, password}).finally(() => setLoading(false));
    },
    [formData, login],
  );

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 w-100">
      <div className="d-flex justify-content-center align-items-center w-100">
        <div
          className="p-3 shadow-lg d-flex flex-column justify-content-between w-100"
          style={{
            width: '350px',
            background: 'white',
            height: '100vh',
            backgroundImage: `url("images/splash/splash-bg.png")`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          {/* You can add a top element here if needed */}
          <div
            className="mt-auto text-white cards rounded-4 pt-[29px] pb-[33px] px-[24px] mt-[28px] primary-gradient-border"
            style={{
              background: '#000000E5',
              backdropFilter: 'blur(30px)',
            }}
          >
            <div className="mb-2 position-relative" style={{zIndex: 1}}>
              <h1 className="fw-bold p-0 m-0" style={{fontSize: '20px', width: '80%'}}>
                Log in to Mapex.app
              </h1>
              <p className="p-0" style={{fontSize: '10px'}}>
                Don’t have account?{' '}
                <a href="/register" className="text-primary">
                  Sign Up Now
                </a>
              </p>

              <form onSubmit={handleSubmit}>
                <div className="">
                  <label className="form-label text-white-50 m-0" style={{fontSize: '10px'}}>
                    Email or Phone
                  </label>
                  <input
                    type="text"
                    className="form-control gn-input-class text-white border-0 py-3"
                    placeholder="Email or Phone"
                    name="username"
                    value={formData.username || ''}
                    onChange={handleChange}
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label text-white-50 m-0" style={{fontSize: '10px'}}>
                    password
                  </label>
                  <input
                    type="text"
                    className="form-control gn-input-class text-white border-0 py-3"
                    placeholder="***********"
                    name="password"
                    value={formData.password || ''}
                    onChange={handleChange}
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      color: '#fff',
                    }}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100 py-3 mb-3"
                  style={{
                    backgroundColor: '#2E2CB2',
                    border: 'none',
                    fontSize: '13px',
                  }}
                  disabled={!formData.username || !formData.password}
                >
                  {loading ? <div className="loader" /> : 'Login'}
                </button>

                <div className="text-center px-5">
                  <p
                    className="form-check-label text-white"
                    htmlFor="termsAgreed"
                    style={{
                      fontSize: '10px',
                      lineHeight: '15px',
                    }}
                  >
                    By submiting your email, you confirm you have read this{' '}
                    <a href="#" className="text-primary">
                      Privacy Notice
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* <div
          className="card p-4 shadow-lg"
          style={{ width: "350px", borderRadius: "15px", background: "white" }}
        >
          <h3 className="fw-bold" style={{ color: "#898989" }}>PayApp</h3>
          <p>Login to your Account.</p>

          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label-always-active color-highlight font-11">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label-always-active color-highlight font-11">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="mb-3 form-check d-flex gap-2 align-items-center">
              <input
                type="checkbox"
                className="form-check-input p-0"
                id="rememberMe"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
              />
              <label
                className="form-label-always-active color-highlight font-11 p-0"
                htmlFor="rememberMe"
              >
                Remember this account
              </label>
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
              {isLoading ? "Signing in..." : "SIGN IN"}
            </button>
          </form>

          <div className="d-flex justify-content-end mt-3">
            <Link to="/register" style={{ textDecoration: "none" }}>
              Create Account
            </Link>
          </div>
        </div> */}
      </div>
    </div>
  );
};
